import { Box, IconButton, Modal } from "@mui/material";
import { identity } from "lodash";
import CloseIcon from "@mui/icons-material/Close";
import {
  TransformComponent,
  TransformWrapper,
  useControls,
} from "react-zoom-pan-pinch";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";

export const ImageModal = ({ open = false, onClose = identity, url = "" }) => {
  const Controls = () => {
    const { zoomIn, zoomOut, resetTransform } = useControls();

    return (
      <Box
        className="tools"
        sx={{
          color: "#fff",
          display: "flex",
          gap: 1,
          justifyContent: "flex-end",
          right: 40,
          bottom: 40,
          position: "absolute",
        }}
      >
        <Box sx={{ background: "rgba(0, 0, 0, 0.7)", borderRadius: 2 }}>
          <IconButton onClick={() => zoomIn()}>
            <AddIcon style={{ fill: "#fff" }} />
          </IconButton>
          <IconButton onClick={() => zoomOut()}>
            <RemoveIcon style={{ fill: "#fff" }} />
          </IconButton>
          <IconButton onClick={() => resetTransform()}>
            <RotateLeftIcon style={{ fill: "#fff" }} />
          </IconButton>
        </Box>
      </Box>
    );
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#fff",
            paddingTop: 2,
            flexShrink: 0,
            width: 700,
            maxWidth: "90vw",
            maxHeight: "90vh",
            scrollSnapAlign: "center",
            borderRadius: 2,
            boxShadow: 3,
            "& img": {
              width: "100%",
              height: "calc(100% - 60px)",
              borderRadius: "inherit",
              objectFit: "cover",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              borderBottomWidth: 2,
              paddingBottom: 1,
              paddingRight: 2,
            }}
          >
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ position: "relative", cursor: "move", padding: 4 }}>
            <TransformWrapper
              defaultScale={1}
              defaultPositionX={0}
              defaultPositionY={0}
              wheel={{ disabled: false }}
              pinch={{ disabled: false }}
              pinchSensitivity={1.5}
              doubleClick={{ disabled: false }}
              smooth={true}
            >
              <TransformComponent>
                <img src={url} alt={`Image`} />
              </TransformComponent>
              <Controls />
            </TransformWrapper>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
